import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./rewardsHeader.css";
import ListRewards from "../Reward Voucher/listReward";
import ListRewardPoints from "../Reward Point/listReward";
import ListUserRewards from "../Reward User/listReward";
import ListDoneUserRewards from "../Reward User Done/listDoneReward";
import { Skeleton } from "antd";

const STORAGE_KEY = "reward_header_tab";

const RewardsHeaderList = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "list_voucher_rewards"
  );
  const [loading, setLoading] = useState(false);

  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;

    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className="bg-white border-10 padding-10 shadow-box">
          <div className="hover_panel">
            <h4
              className={selectedTable === "list_voucher_rewards" ? "clicked" : ""}
              onClick={() => handleTableSelection("list_voucher_rewards")}
            >
              Reward Voucher
            </h4>

            <h4
              className={selectedTable === "list_point_rewards" ? "clicked" : ""}
              onClick={() => handleTableSelection("list_point_rewards")}
            >
              Reward Points
            </h4>

            <h4
              className={selectedTable === "list_user_rewards" ? "clicked" : ""}
              onClick={() => handleTableSelection("list_user_rewards")}
            >
              Reward User
            </h4>

            <h4
              className={selectedTable === "list_done_user_rewards" ? "clicked" : ""}
              onClick={() => handleTableSelection("list_done_user_rewards")}
            >
              Done User Reward
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div style={{ display: loading ? "none" : "block" }} className="fade-wrapper">
          <div
            className="fade-tab"
            style={{ display: selectedTable === "list_voucher_rewards" ? "block" : "none" }}
          >
            <ListRewards />
          </div>

          <div
            className="fade-tab"
            style={{ display: selectedTable === "list_point_rewards" ? "block" : "none" }}
          >
            <ListRewardPoints />
          </div>

          <div
            className="fade-tab"
            style={{ display: selectedTable === "list_user_rewards" ? "block" : "none" }}
          >
            <ListUserRewards />
          </div>

          <div
            className="fade-tab"
            style={{ display: selectedTable === "list_done_user_rewards" ? "block" : "none" }}
          >
            <ListDoneUserRewards />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default RewardsHeaderList;
